/**
 *
 * Address.mixin
 *
 */

import { mapActions, mapGetters } from 'vuex';

export const AddressEditMixin = {
  name: 'AddressEditMixin',

  computed: {
    ...mapGetters('Mixins/AddressEdit', {
      mg_myAddresses: 'myAddresses',
      mg_myDefaultAddress: 'myDefaultAddress',
    }),

    c_isHaveAddress() {
      return this.mg_myAddresses.length > 0;
    },

    c_isHaveAddressOnlyOne() {
      return 1 === this.mg_myAddresses.length;
    },
  },

  methods: {
    ...mapActions('Mixins/AddressEdit', {
      ma_getStudentAddress: 'getStudentAddress',
      ma_makeNewAddress: 'makeNewAddress',
      ma_deleteAddress: 'deleteAddress',
    }),
  },
};

export default AddressEditMixin;
